import type { ResolvedGeo } from '@/cloud/services/cloud-api.service';

/** `51.6105°N, 0.5546°W`. */
export function formatCoordinates(latitude: number, longitude: number): string {
    const latDir = latitude >= 0 ? 'N' : 'S';
    const lngDir = longitude >= 0 ? 'E' : 'W';
    return `${Math.abs(latitude).toFixed(4)}°${latDir}, ${Math.abs(longitude).toFixed(4)}°${lngDir}`;
}

export function googleMapsUrl(latitude: number, longitude: number): string {
    return `https://www.google.com/maps?q=${latitude},${longitude}`;
}

/** Where a resolved position came from, in words: an override, the location it's inherited from, or the IP estimate. */
export function geoSourceLabel(geo: ResolvedGeo): string {
    switch (geo.source) {
        case 'manual':
            return 'Manual override';
        case 'location':
            return geo.sourceLocationName ? `Inherited from ${geo.sourceLocationName}` : 'Inherited from its location';
        default:
            return 'Approximate — based on public IP';
    }
}
